/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Une remise HBS générée (ligne du tableau des remises). Identifiée par son id (Guid) — jamais par sa date. Peut contenir 0 contrat (remise tracée par le job mensuel même sans affaire nouvelle) : dans ce cas, aucune action (ni download ni confirmation).
 * 
 * @export
 * @interface HbsRemiseListItem
 */
export interface HbsRemiseListItem {
    /**
     * Identifiant de la remise, utilisé par les routes de download / confirmation
     * @type {string}
     * @memberof HbsRemiseListItem
     */
    id: string;
    /**
     * Date de génération (ISO datetime)
     * @type {string}
     * @memberof HbsRemiseListItem
     */
    generationDate: string;
    /**
     * Nombre d'affaires nouvelles incluses (0 possible)
     * @type {number}
     * @memberof HbsRemiseListItem
     */
    contractsCount: number;
    /**
     * true = dépôt sur le portail HBS confirmé pour toute la remise
     * @type {boolean}
     * @memberof HbsRemiseListItem
     */
    isUploaded: boolean;
    /**
     * Date de confirmation de l'upload (ISO datetime), null si non confirmé
     * @type {string}
     * @memberof HbsRemiseListItem
     */
    uploadConfirmedAt?: string | null;
}

/**
 * Check if a given object implements the HbsRemiseListItem interface.
 */
export function instanceOfHbsRemiseListItem(value: object): value is HbsRemiseListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('generationDate' in value) || value['generationDate'] === undefined) return false;
    if (!('contractsCount' in value) || value['contractsCount'] === undefined) return false;
    if (!('isUploaded' in value) || value['isUploaded'] === undefined) return false;
    return true;
}

export function HbsRemiseListItemFromJSON(json: any): HbsRemiseListItem {
    return HbsRemiseListItemFromJSONTyped(json, false);
}

export function HbsRemiseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): HbsRemiseListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'generationDate': json['generationDate'],
        'contractsCount': json['contractsCount'],
        'isUploaded': json['isUploaded'],
        'uploadConfirmedAt': json['uploadConfirmedAt'] == null ? undefined : json['uploadConfirmedAt'],
    };
}

export function HbsRemiseListItemToJSON(json: any): HbsRemiseListItem {
    return HbsRemiseListItemToJSONTyped(json, false);
}

export function HbsRemiseListItemToJSONTyped(value?: HbsRemiseListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'generationDate': value['generationDate'],
        'contractsCount': value['contractsCount'],
        'isUploaded': value['isUploaded'],
        'uploadConfirmedAt': value['uploadConfirmedAt'],
    };
}

